import {
  SET_MENUS_AUTH,
  SET_MENUS_AUTH_SUCCESS,
  SET_AUTH_INFO,
  SET_ACCOUNT_BALANCE,
  SET_ACCOUNT_TYPE,
  SET_RECHARGE_VISIBLE,
} from '../../type/bizGlobal.ts';

const initialState: any = {
  menusAuth: [],
  setMenuAuthSuccess: false,
  authInfo: {},
  accountBalance: {},
  accountType: 'office', // person 或 office，默认 office
  rechargeVisible: false, // 全局控制充值窗口显隐
};

export default function reducer(state = initialState, action: any) {
  const { type, payload } = action;

  switch (type) {
    case SET_MENUS_AUTH: {
      return {
        ...state,
        menusAuth: [
          ...payload,
          // { access: 'realEstate:tab:balanceManage' }, // todo: 余额管理权限，开发时添加，上线后需要删除
        ],
      };
    }

    case SET_MENUS_AUTH_SUCCESS: {
      return {
        ...state,
        setMenuAuthSuccess: payload,
      };
    }

    case SET_AUTH_INFO: {
      return {
        ...state,
        authInfo: {
          ...payload,
          // statusCode: 2,
        },
      };
    }

    case SET_ACCOUNT_BALANCE: {
      return {
        ...state,
        accountBalance: payload,
      };
    }

    case SET_ACCOUNT_TYPE: {
      localStorage.setItem('ACCOUNT_TYPE', payload);
      return {
        ...state,
        accountType: payload,
      };
    }

    case SET_RECHARGE_VISIBLE: {
      return {
        ...state,
        rechargeVisible: payload,
      };
    }

    default:
      return state;
  }
}
